import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "../lib/api";

export default function Reviews() {
    const [reviews, setReviews] = useState([]);
    useEffect(() => {
        api.get("/reviews").then((r) => setReviews(r.data || []));
    }, []);
    return (
        <div className="min-h-screen bg-navy-900">
            <section className="bg-navy-950 border-b border-white/5">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
                    <div className="label-overline mb-3">Trust & Reviews</div>
                    <h1 className="font-heading text-4xl lg:text-6xl font-bold text-white">Real stories from <span className="text-gold-500">verified customers.</span></h1>
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
                {reviews.length === 0 ? (
                    <SampleTestimonials />
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 stagger">
                        {reviews.map((r) => (
                            <div key={r.id} className="rounded-2xl bg-navy-800 border border-white/5 p-6">
                                <div className="flex gap-0.5 text-gold-500 mb-3">
                                    {[1,2,3,4,5].map((i) => <Star key={i} className={`w-4 h-4 ${i <= r.rating ? "fill-gold-500" : "opacity-30"}`} />)}
                                </div>
                                {r.comment && <p className="text-white/80 text-sm leading-relaxed">"{r.comment}"</p>}
                                <div className="text-gold-500 font-semibold text-sm mt-4">— {r.user_name}</div>
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}

function SampleTestimonials() {
    const samples = [
        { name: "Aakash M.", rating: 5, text: "Found my dream 3 BHK in Nagpur within 2 weeks. The broker was RERA-verified and handled all paperwork. Premium experience!" },
        { name: "Priya V.", rating: 5, text: "The advocate they connected me with caught a 22-year-old encumbrance issue. Saved me from a 1.4 Cr disaster." },
        { name: "Rohit K.", rating: 4, text: "Loan agent got me 0.4% lower than what HDFC offered me directly. Clean process, no hidden fees." },
        { name: "Meena S.", rating: 5, text: "Listed my Pune flat — sold in 38 days at asking price. The verified-listing badge made all the difference." },
        { name: "Vikram J.", rating: 5, text: "One platform for everything. Bought a plot, got it registered, and arranged loan — all without leaving the site." },
        { name: "Neha P.", rating: 5, text: "Customer service is real. Got a callback within 30 minutes when I had questions about stamp duty." },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 stagger">
            {samples.map((s, i) => (
                <div key={i} className="rounded-2xl bg-navy-800 border border-white/5 p-6 hover:border-gold-500/40 hover-lift">
                    <div className="flex gap-0.5 text-gold-500 mb-3">
                        {[1,2,3,4,5].map((j) => <Star key={j} className={`w-4 h-4 ${j <= s.rating ? "fill-gold-500" : "opacity-30"}`} />)}
                    </div>
                    <p className="text-white/80 text-sm leading-relaxed">"{s.text}"</p>
                    <div className="text-gold-500 font-semibold text-sm mt-4">— {s.name}</div>
                </div>
            ))}
        </div>
    );
}
